var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskMinimizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 400.8 350.2",
    style: {
      enableBackground: "new 0 0 400.8 350.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("path", {
    d: "M337.2 77.2 309.4 93l-23.1 35.1c21.7 21.7 35.1 51.7 35.1 84.9 0 28.2-9.7 54.2-26 74.6-4.9 6.1-4.4 15 1.2 20.5l29.2 29.2c6.4 6.4 16.9 6 22.8-1 28-33.4 44.9-76.4 44.9-123.4-.1-52.9-21.6-100.9-56.3-135.7zm0 0",
    style: {
      fill: "#7741af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4 213c0-33.1 13.4-63.1 35.1-84.9L93.4 93 65.6 77.2C30.9 112 9.4 160 9.4 213c0 47 16.9 90 44.9 123.4 5.8 6.9 16.4 7.4 22.8 1l29.2-29.2c5.5-5.5 6.1-14.4 1.2-20.5-16.4-20.5-26.1-46.5-26.1-74.7zm0 0",
    style: {
      fill: "#bd88ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.4 93c33.1 0 63.1 13.4 84.9 35.1l50.9-50.9C302.4 42.5 254.4 21 201.4 21s-101 21.5-135.8 56.2l50.9 50.9c21.8-21.7 51.8-35.1 84.9-35.1zm0 0",
    style: {
      fill: "#a16bdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.2 77.2 325.3 84c23.4 31.8 37.2 71.1 37.2 113.6 0 35-9.4 67.8-25.7 96-7.6 13.2-21.3 20-35.1 19.8l24 24c6.4 6.4 16.9 6 22.8-1 28-33.4 44.9-76.4 44.9-123.4 0-53-21.5-101-56.2-135.8zm0 0",
    style: {
      fill: "#763ab5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m327.5 86.9 9.7-9.7c-18.6-18.6-40.9-33.4-65.8-43.1 22 13.7 41.1 31.7 56.1 52.8zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m166.4 186.3 19.5-10.8 11 59-22.1-3c-10.3-1.4-20.7-1.2-30.9.7l-73.1 13.6c-9.8 1.8-19.2-4.6-21-14.4-1.8-9.8 4.6-19.2 14.4-21l73.1-13.6c10.2-2 20.1-5.5 29.1-10.5zm0 0",
    style: {
      fill: "#9163c1"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.3 200c1.5-19.8 18.8-34.6 38.7-33.1 19.8 1.5 34.6 18.9 33.1 38.7-1.5 19.8-18.8 34.6-38.7 33.1-19.8-1.6-34.6-18.9-33.1-38.7zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskMinimizeIcon);
export default __webpack_public_path__ + "static/media/riskMinimizeIcon.b5f0a02ccb38f2dd1c4cc7385165ad1f.svg";
export { ForwardRef as ReactComponent };